import $ from 'jquery';

$(function() {
  $(".image-swap-svg-wrapper").on('mouseenter', function () {
    var s = $(this).find(".image-swap-svg-item")[0],
      a = $(this).find(".image-swap-mask-circle"),
      i = $(this).find(".image-swap-circle-shadow"),
      n = s.createSVGPoint();
    $(this).on('mousemove', function (e) {
      var t;
      (e = e), (t = s), (n.x = e.clientX), (n.y = e.clientY), (e = n.matrixTransform(t.getScreenCTM().inverse())), a.attr("cx", e.x), a.attr("cy", e.y), i.attr("cx", e.x), i.attr("cy", e.y);
    });
  }),
  $(".svg-wrapper").on('mouseleave', function () {
      $(".mask-circle").attr({ cx: "0", cy: "50%" }), $(".image-swap-circle-shadow").attr({ cx: "0", cy: "50%" });
  });
})
